import type {
  ViewpointReportListResult,
  ViewpointReportRow,
  ViewpointReportSubmitParam,
} from "./ViewpointReportTypes";
import { REPORT_TARGET_TYPE_VIEWPOINT } from "./ViewpointReportTypes";
import type { ViewpointFeedPost } from "./ViewpointFeedTypes";

const now = "2026-06-21 10:00:00";

function buildTargetContent(post: ViewpointFeedPost, spaceProductId: string): string {
  return JSON.stringify({
    spaceProductId,
    targetId: post.id,
    snapshot: {
      id: post.id,
      content: post.content,
      title: post.title,
      titleMode: post.titleMode,
      publisherNickname: post.publisherNickname,
      publisherLabel: post.publisherLabel,
      publisherAvatarUrl: post.publisherAvatarUrl,
      publishedAt: post.publishedAt,
      categoryName: post.categoryName,
      imageUrls: post.imageUrls,
    },
  });
}

const mockRows: ViewpointReportRow[] = [
  {
    id: "RMOCK001",
    reportTargetType: REPORT_TARGET_TYPE_VIEWPOINT,
    reportTargetTypeLabel: "观点",
    reportTargetContent: JSON.stringify({
      spaceProductId: "PMOCK001",
      targetId: "VMOCK001",
      snapshot: {
        content: "今日关注某龙头，建议重点关注。",
        publisherNickname: "演示用户",
        publishedAt: "6月20日 15:30",
      },
    }),
    reportType: "stock_recommend",
    reportTypeLabel: "推荐股票",
    detailNote: "疑似明示荐股",
    status: "pending",
    statusLabel: "待处理",
    handleResult: "",
    createdAt: now,
    handledAt: "",
  },
];

export function mockSubmitReport(param: ViewpointReportSubmitParam): string {
  const id = `RMOCK${Date.now()}`;
  mockRows.unshift({
    id,
    reportTargetType: param.reportTargetType,
    reportTargetTypeLabel:
      param.reportTargetType === REPORT_TARGET_TYPE_VIEWPOINT ? "观点" : param.reportTargetType,
    reportTargetContent: buildTargetContent(
      {
        id: param.targetId,
        content: "（Mock 举报内容）",
        title: "",
        titleMode: false,
        imageUrls: [],
        categoryId: "",
        categoryName: "",
        importance: "normal",
        visibility: "all",
        publishedAt: now,
        publisherLabel: "用户",
        hidden: false,
        audienceTagIds: [],
        audienceTagMatchMode: "any",
        syncToWechat: false,
        likeCount: 0,
        collectCount: 0,
      },
      param.spaceProductId
    ),
    reportType: param.reportType,
    reportTypeLabel:
      param.reportType === "stock_recommend"
        ? "推荐股票"
        : param.reportType === "promised_return"
          ? "承诺收益"
          : param.reportType === "political"
            ? "涉及政治"
            : param.reportType === "porn_violence"
              ? "色情暴力"
              : param.reportType,
    detailNote: param.detailNote?.trim() ?? "",
    status: "pending",
    statusLabel: "待处理",
    handleResult: "",
    createdAt: now,
    handledAt: "",
  });
  return id;
}

export function mockListMyReports(pageNum = 1, pageSize = 20): ViewpointReportListResult {
  const start = (pageNum - 1) * pageSize;
  const list = mockRows.slice(start, start + pageSize);
  return { total: mockRows.length, list };
}
